import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Grid } from "@mui/material";
import { Form, Formik, FormikHelpers } from "formik";
import InputField from "../Reuseables/Fields/InputField";
import addUserFormModel from "./addUserFormModel";
import * as Yup from "yup";
import SelectField from "../Reuseables/Fields/SelectField";
import { useApplicationContext } from "../ContextProviders/ApplicationContext";
import { Role } from "../../types/enums";
import { UserTypeOptions } from "../../helpers/selectOptions";
import { useMsal } from "@azure/msal-react";
import { CustomAccountInfo } from "../../types/customAccountInfo";
import { RoleComponentGuard } from "../Reuseables/Guards/RoleComponentGuard";
import { useOrganizationContext } from "../ContextProviders/OrganizationContext";
import { inviteUser } from "../../api/workspace";

const { formField } = addUserFormModel;

type WorkspaceCreationType = {
  workspaceId?: string;
  tenantName: string;
  displayName?: string;
  email: string;
  confirmEmail: string;
  userType: Role;
};
//TODO Move validation etc.
//TODO CONFIRM CORRECT WORKSPACE
export default function InviteUser() {
  const { instance } = useMsal();
  const account = instance.getActiveAccount() as CustomAccountInfo;
  let role = account?.idTokenClaims?.role;
  const { activeWorkspace } = useOrganizationContext();
  
  
  const initialValues: WorkspaceCreationType = {
    workspaceId: activeWorkspace.workspaceId,
    tenantName: activeWorkspace.tenantName,
    displayName: activeWorkspace.displayName,
    email: "",
    confirmEmail: "",
    userType: Role.SolutionOwner, // Make sure this is default. or do role check if we ever have to change the default.
  };

  const { showSnackbar } = useApplicationContext();
  const _handleSubmit = async (
    values: WorkspaceCreationType,
    actions: FormikHelpers<WorkspaceCreationType>
  ) => {
    try {
      let user = await inviteUser({
        ...values,
      });
      showSnackbar(`Invitation sent to ${user.email}`, "success");
      actions.setSubmitting(false);
    } catch (error: unknown) {
      if (error instanceof Error) {
        showSnackbar(error.message, "error");
      } else {
        showSnackbar("Unknown error", "error");
      }
    }
    actions.resetForm();
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("errors.invalid").required("errors.required"),
    confirmEmail: Yup.string().when(() => {
      return Yup.string().test(
        "email-match",
        "errors.emailNoMatch",
        function (value) {
          return this.parent.email === value;
        }
      );
    }),
  });

  return (
    <Box display="flex" justifyContent="center" sx={{ mt: 5 }}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={_handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form style={{ width: "100%" }}>
            <Grid container>
              <Grid item xs />
              <Grid item xs={12} sm={6} md={5} lg={4}>
                <Box
                  sx={{
                    "& .MuiTextField-root": { m: 2 },
                  }}
                >
                  <Box>
                    <InputField
                      name={formField.displayName.name}
                      label={formField.displayName.label}
                      disabled
                    />
                  </Box>
                  <Box>
                    <InputField
                      name={formField.email.name}
                      label={formField.email.label}
                    />
                  </Box>
                  <Box>
                    <InputField
                      name={formField.confirmEmail.name}
                      label={formField.confirmEmail.label}
                    />
                  </Box>
                  <RoleComponentGuard roles={[Role.PrecureAdmin]}>
                  <Box>
                    <SelectField
                      fullWidth
                      name={formField.userType.name}
                      label={formField.userType.label}
                      //Disabled Local coordinator
                      data={UserTypeOptions.filter(
                        (e) => e.value !== Role.LocalCoordinator
                      )}
                    />
                  </Box>
                  </RoleComponentGuard>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    sx={{ m: 2 }}
                  >
                    {isSubmitting ? (
                      <Button variant="contained" disabled>
                        <CircularProgress size={20} />
                        Saving
                      </Button>
                    ) : (
                      <Button
                        disabled={isSubmitting}
                        type="submit"
                        variant="contained"
                      >
                        Invite
                      </Button>
                    )}
                  </Box>
                </Box>
              </Grid>
              <Grid item xs />
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
